import { combineReducers } from 'redux';

import { SELECT_DEALER } from 'constants/ActionTypes';
import error from 'modules/global/reducers/generic.error';
import loading from 'modules/global/reducers/generic.loading';
import * as types from 'modules/selfServices/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {{
 *   loading: {
 *     general: boolean,
 *     public: boolean,
 *   },
 *   error: {
 *     general: string,
 *     public: string,
 *   },
 *   publicUrl: string,
 * }} SelfServiceOnSiteLinkReducer
 */

const targetMatcher = target => action => action.meta?.target === target;

const initialState = null;

/** @param {'public' | 'general'} target  */
const reset =
  target =>
    /**
     * @param {string} state
     * @param {import('modules/selfServices/types').GetOnSiteLinkAction | import('modules/selfServices/types').GetOnSiteLinkFailureAction} target
     * @returns {string}
     */
    (state, action) =>
      (targetMatcher(target)(action) ? initialState : state);

/** @param {'public' | 'general'} target  */
const set =
  target =>
    /**
     * @param {string} _
     * @param {import('modules/selfServices/types').GetOnSiteLinkSuccessAction} action
     * @returns {string}
     */
    (state, action) =>
      (targetMatcher(target)(action) ? action.payload.url : state);

const resetMatcher = {
  matcher: action => action.type === SELECT_DEALER,
  reducer: () => null,
};

/** @param {'public' | 'general'} target */
const onSiteURLReducer = target =>
  createReducer(
    initialState,
    {
      [types.GET_ON_SITE_LINK]: reset(target),
      [types.GET_ON_SITE_LINK_SUCCESS]: set(target),
      [types.GET_ON_SITE_LINK_FAILURE]: reset(target),
    },
    [resetMatcher]
  );

export default combineReducers({
  loading: combineReducers({
    general: loading(types.GET_ON_SITE_LINK, { global: { matcher: targetMatcher('general') } }),
    public: loading(types.GET_ON_SITE_LINK, { global: { matcher: targetMatcher('public') } }),
  }),
  error: combineReducers({
    general: error(types.GET_ON_SITE_LINK, {
      global: { matcher: targetMatcher('general') },
      matchers: [resetMatcher],
    }),
    public: error(types.GET_ON_SITE_LINK, {
      global: { matcher: targetMatcher('public') },
      matchers: [resetMatcher],
    }),
  }),
  publicUrl: onSiteURLReducer('public'),
});
